export function isQuoteId(value: string): boolean {
    const quotPattern = /^Q\w{9}$/;// string starting with Q and followed by 9 alphanumeric chars
    return quotPattern.test(value);
}